import {
  initBalanceTableOptsSlice,
  initBalanceTableOptsState,
} from 'src/store/shared/balance-table-opts/factory';

const initialState = initBalanceTableOptsState({
  isDuplicatesVisible: true,
  isInitialBalanceUsed: false,
  isIgnoreOtherTokens: true,
});

const { reducer, actions } = initBalanceTableOptsSlice({
  sliceName: 'loansBalancesUI',
  initialState,
});

export const balanceTableOptsActions = actions;

export default reducer;
